import IconUse from '_/ui/icons/use'
import { tv } from 'tailwind-variants'

const styles = tv(
	{
		slots: {
			pdf: 'text-primary-neutral font-bold underline flex items-center gap-x-3.5 print:hidden',
		},
		variants: {
			size: {
				sm: {
					pdf: 'text-base',
				},
				md: {
					pdf: 'text-lg',
				},
			},
		},
	},
	{
		responsiveVariants: ['sm', 'md'],
	},
)

const { pdf } = styles({
	size: {
		initial: 'sm',
		md: 'md',
	},
})

export const ViewPDF = () => (
	<button className={pdf()} onClick={() => window.print()}>
		View PDF <IconUse id='arrow-right' width={19} height={19} className='fill-transparent -rotate-45' />
	</button>
)
